import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getAllCategories as fetchAllCategories } from '../../api/ManApi';
import { IDocumentView } from '../providers/providerTypes';
import { RootState, TThunkApi } from 'store/store';

export type CategoryActiveStatus = 'Active' | 'ComingSoon' | 'InActive';
export interface ICategory {
  id: number;
  parent?: number;
  name?: string;
  activeStatus?: CategoryActiveStatus;
  icon?: IDocumentView;
  documents?: IDocumentView[];
}

export interface ICategories {
  [key: number]: ICategory;
}

const initialState: ICategories = {};

const addOrUpdateCategoriesHandler = (
  state: ICategories,
  action: PayloadAction<{ categories: Array<ICategory> }>
) => {
  action.payload.categories.forEach((category) => {
    category.icon = category.documents?.filter(
      (it) => it.documentType === 'category_icon'
    )?.[0];
    state[category.id] = category;
  });
};

export const getAllCategoriesFn = async (_: any, ThunkApi: TThunkApi) => {
  const store = ThunkApi.getState() as RootState;
  return fetchAllCategories(store).then(({ data: categories }) => {
    ThunkApi.dispatch(addOrUpdateCategories({ categories }));
    return Promise.resolve({ categories });
  });
};
const getAllCategories = createAsyncThunk(
  'categories/getAllCategories',
  getAllCategoriesFn
);

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: initialState,
  reducers: {
    addOrUpdateCategories: addOrUpdateCategoriesHandler,
  },
});

export const { addOrUpdateCategories } = categoriesSlice.actions;

export { getAllCategories };

export default categoriesSlice.reducer;
